import { createReducer, on } from '@ngrx/store';
import * as fromPaymentsActions from '../actions';

export const notifyIndividualFeatureKey = 'notifyIndividual';

export interface NotifyIndividualState {
  success: string | null;
  failure: any | null;
  loading: boolean;
}

export const initialState: NotifyIndividualState = {
  success: null,
  failure: null,
  loading: false
};

export const notifyIndividualReducer = createReducer(
  initialState,
  on(fromPaymentsActions.notifyIndividualOutstanding, (state) => ({
    ...state,
    success: null,
    failure: null,
    loading: true
  })),
  on(fromPaymentsActions.notifyIndividualOutstandingSuccess, (state, { response }) => ({
    ...state,
    success: response,
    failure: null,
    loading: false
  })),
  on(fromPaymentsActions.notifyIndividualOutstandingFailure, (state, { error }) => ({
    ...state,
    success: null,
    failure: error,
    loading: false
  }))
);
